import { call, put } from "redux-saga/effects";
import httpErrorHelpers from "../../services/httpUtilities/httpErrorHelpers";
import api from "../../services/httpUtilities/httpService";
import * as authAction from "../actions/auth";
import AuthManager from "../../utils/AuthManager";

function* watcherPostLoginRequest({ userID, password,authClientID,authRedirectUrl,authState,recaptchaToken,code,twoFAReferenceCode }, effects) {
  try {
    const response = yield call(api.postLoginRequest, userID, password,authClientID,authRedirectUrl,authState,recaptchaToken,code,twoFAReferenceCode);
    const { data, status } = response;
    const { Message } = data;
   //console.log("response",response)
    if (status === 200) {
      yield put(authAction.postLoginSuccess(data));
    } else {
      const message = "Post Login Request Unsuccessful";
      yield put(authAction.postLoginFailure(message));
    }
  } catch (error) {
    //console.log("error",error.response)
    yield put(authAction.postLoginSuccess(error.response));
    yield call(httpErrorHelpers, error, authAction.postLoginFailure, effects);
  }
}

function* watcherPostConfirmLoginRequest(
  { loginRequestKey, twoFAReferenceCode },
  effects
) {
  try {
    const response = yield call(
      api.postConfirmLoginRequest,
      loginRequestKey,
      twoFAReferenceCode
    );
    const { data, status } = response;
    const { Message } = data;
   
    if (status === 200) {
      yield put(authAction.postConfirmLoginSuccess(data.Data));
    } else {
      const message = "Get Inquiry List Unsuccessful";
      yield put(authAction.postConfirmLoginFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      authAction.postConfirmLoginFailure,
      effects
    );
  }
}

//Forgot User Id Request
function* watcherPostForgotUserIdRequest({ userID, birthdate,recaptchaToken }, effects) {
  try {
    const response = yield call(api.postForgotUserId, userID, birthdate,recaptchaToken);
    const { data, status } = response;
    const { Message } = data;
   
    if (status === 200) {
      yield put(authAction.postForgotUserIdSuccess(data.Data));
    } else {
      const message = "Submit forgot User Id Failure";
      yield put(authAction.postForgotUserIdFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      authAction.postForgotUserIdFailure,
      effects
    );
  }
}

//Get Current User ID
function* watcherGetCurrentUserIdRequest(
  { userID, code2Fa, otpReference },
  effects
) {
  try {
    const response = yield call(
      api.getCurrentUserId,
      userID,
      code2Fa,
      otpReference
    );
    const { data, status } = response;
    const { Message } = data;
   
    if (status === 200) {
      yield put(authAction.getCurrentUserIdSuccess(data.Data));
    } else {
      const message = "Get Current User Id failure";
      yield put(authAction.getCurrentUserIdFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      authAction.getCurrentUserIdFailure,
      effects
    );
  }
}

//Resend Otp
function* watcherResendOtpRequest({ userID,recaptchaToken }, effects) {
  try {
    const response = yield call(api.resendOtp, userID,recaptchaToken);
    const { data, status } = response;
    const { Message } = data;
   
    if (status === 200) {
      yield put(authAction.resendOtpSuccess(data.Data));
    } else {
      const message = "Resend Otp Failure";
      yield put(authAction.resendOtpFailure(message));
    }
  } catch (error) {
    yield call(httpErrorHelpers, error, authAction.resendOtpFailure, effects);
  }
}

//Forgot Password Request
function* watcherForgotPasswordRequest({ userID, birthdate,recaptchaToken }, effects) {
  try {
    const response = yield call(api.forgotPasswordReq, userID, birthdate,recaptchaToken);
    const { data, status } = response;
    const { Message } = data;
   //console.log("response",response)
    if (status === 200) {
      yield put(authAction.forgotPasswordRequestSuccess(data));
    } else {
      const message = "Submit forgot Password Failure";
      yield put(authAction.forgotPasswordRequestFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      authAction.forgotPasswordRequestFailure,
      effects
    );
  }
}

//Verify Forgot Pass Otp
function* watcherVerifyForgotPassOtpRequest(
  { code2Fa, otpReference },
  effects
) {
  try {
    const response = yield call(
      api.verifyForgotPassOtpRequest,
      code2Fa,
      otpReference
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("resposne",response)
    if (status === 200) {
      yield put(authAction.verifyForgotPassOtpSuccess(data.Data));
    } else {
      const message = "Verify Forgot Pass Otp failure";
      yield put(authAction.verifyForgotPassOtpFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      authAction.verifyForgotPassOtpFailure,
      effects
    );
  }
}

//Chnage Password Request
function* watcherChangePasswordRequest(
  { userID, password, confirmPassword, otpReference },
  effects
) {
  try {
    const response = yield call(
      api.changePasswordRequest,
      userID,
      password,
      confirmPassword,
      otpReference
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("response",response)
    if (status === 200) {
      yield put(authAction.changePasswordSuccess(data.Data));
    } else {
      const message = "Change Password failure";
      yield put(authAction.changePasswordFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      authAction.changePasswordFailure,
      effects
    );
  }
}

//Login Portal Request
function* watcherLoginPortalRequest(
  { actionId, authClientId, authRedirectUrl, authState },
  effects
) {
  try {
    const response = yield call(
      api.loginPortal,
      actionId,
      authClientId,
      authRedirectUrl,
      authState
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("res",response)
    if (status === 200) {
      yield put(authAction.loginPortalSuccess(data.Data));
    } else {
      const message = "Get login Portal failure";
      yield put(authAction.loginPortalFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      authAction.loginPortalFailure,
      effects
    );
  }
}

//Get Authorization Auth Code
function* watcherGetAuthorizationAuth(
  { authState, authRedirectUrl },
  effects
) {
  try {
    const response = yield call(
      api.getAuthorizationAuth,
      authState,
      authRedirectUrl
    );
    const { data, status } = response;
    const { Message } = data;
   
    if (status === 200) {
      yield put(authAction.getAuthorizationAuthSuccess(data.Data));
    } else {
      const message = "Get Authorizatio Auth Failure";
      yield put(authAction.getAuthorizationAuthFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      authAction.getAuthorizationAuthFailure,
      effects
    );
  }
}
//Auth token
function* watcherGetAuthToken({ nric }, effects) {
  try {
    const response = yield call(api.getAuthToken, nric);
    const { data, status } = response;
    const {Token} = data;
   
    if (status === 200) {
      yield put(authAction.getAuthTokenSuccess(Token));
      AuthManager.setToken(Token);
    } else {
      const message = "Get Auth Token Unsuccessful";
      yield put(authAction.getAuthTokenFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      authAction.getAuthTokenFailure,
      effects
    );
  }
}

//Get SingPass
function* watcherGetSingPass(
  { authState,authCode },
  effects
) {
  try {
    const response = yield call(
      api.getSingPass,
      authState,authCode
    );
    const { data, status } = response;
    const { Message } = data;
   //console.log("res",response)
    if (status === 200) {
      yield put(authAction.getSingPassSuccess(data.Data));
    } else {
      const message = "Get SingPass Auth Failure";
      yield put(authAction.getSingPassFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      authAction.getSingPassFailure,
      effects
    );
  }
}

//Get SingPass
function* watcherGetMaintenanceMsg(
  {  },
  effects
) {
  try {
    const response = yield call(
      api.getMaintenanceMsg,
      
    );
    const { data, status } = response;
    const { Message } = data;
   //console.log("res",response)
    if (status === 200) {
      yield put(authAction.getMaintenanceMsgSuccess(data.Data));
    } else {
      const message = "getMaintenanceMsgFailure Failure";
      yield put(authAction.getMaintenanceMsgFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      authAction.getMaintenanceMsgFailure,
      effects
    );
  }
}

function* watcherGenerateLoginOtp({submitData}, effects) {
  try {
    const response = yield call(api.generateLoginOtp,submitData);
    const { data, status } = response;
    //console.log("res",response)
    if (status === 200) {
      yield put(authAction.generateLoginOtpSuccess(data));
    } else {
      const message = "generateLoginOtpFailure Unsuccessful";
      yield put(authAction.generateLoginOtpFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      authAction.generateLoginOtpFailure,
      effects
    );
  }
}

export {
  watcherPostLoginRequest,
  watcherPostConfirmLoginRequest,
  watcherPostForgotUserIdRequest,
  watcherGetCurrentUserIdRequest,
  watcherResendOtpRequest,
  watcherForgotPasswordRequest,
  watcherVerifyForgotPassOtpRequest,
  watcherChangePasswordRequest,
  watcherLoginPortalRequest,
  watcherGetAuthorizationAuth,
  watcherGetAuthToken,
  watcherGetSingPass,
  watcherGetMaintenanceMsg,
  watcherGenerateLoginOtp
};
